import React from 'react';
import styled from 'styled-components';
import { PaddedContainer, SectionName } from '../common/styles';

const Container = styled(PaddedContainer)`
  padding: 0;
  padding-top: ${props => (props.theme.isMobile ? 49 : 194)}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  ${props => (props.theme.isMobile && `
    font-size: 20px;
    line-height: 20px;
  `)};
`;

const Desc = styled.p`
  margin: 20px 0 26px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBook};
  font-size: ${props => (props.theme.isMobile ? 30 : 40)}px;
  line-height: ${props => (props.theme.isMobile ? 35 : 45)}px;
  ${props => (!props.theme.isMobile && `
    max-width: 896px;
    width: 63vw;
  `)};
  text-align: center;
`;

export default function Career() {
  return (
    <Container id="career">
      <Title>work at livewire</Title>
      <Desc>
        Join our team and help shape the way investors discover and make investment decisions
      </Desc>
    </Container>
  );
}
